// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

var getWindowLocation = function() {
	// Escape window.location.href
	var href = window.location.href;
	var escapedHref = href.replace(/%3C/g, '&lt;').replace(/%3E/g, '&gt;');

	// Rebuild window.location.href
	var rebuildHrefArr = [];
	for (var i = 0; i < escapedHref.length; i++) {
		rebuildHrefArr.push(escapedHref.charAt(i));
	}
	var rebuildHref = rebuildHrefArr.join('').split('&lt;').join('%3C').split('&gt;').join('%3E');

	// Rebuild window.location.search
	var rebuildSearch = "";
	var hrefWithoutHash = rebuildHref.replace(/#.*$/, '');
	if (hrefWithoutHash.split('?').length > 1) {
		rebuildSearch = hrefWithoutHash.split('?')[1];
		if (rebuildSearch.length > 0) {
			rebuildSearch = '?' + rebuildSearch;
		}
	}

	return {
		pathname: window.location.pathname,
		href: rebuildHref,
		search: rebuildSearch
	}
}
BCSfFilter.prototype.buildProductItemUrl = function(data, hasCollection) {
    // Get url information
	var params = getWindowLocation().search.substring(1);
	var pathname = window.location.pathname;
	var elements = pathname.split('/');

	// Check if has locale
	var localeURLPart = "";
	var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
	if (hasShopifyRoutes) {
		localeURLPart = Shopify.routes.root.replace(/\/$/, '');
	} else if (elements.indexOf(bcSfFilterMainConfig.general.current_locale) > -1) {
		localeURLPart = "/" + bcSfFilterMainConfig.general.current_locale;
	}

	// Get product handle
	var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
	var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : true;
  
	if (hasCollection) {
		// Homepage or Search page
		if (pathname == '/' || this.isSearchPage() || this.isVendorPage()) {
			var preHandle = localeURLPart + '/collections/all/products/';
			return preHandle + handle;
		// Tag Page
		} else if (this.isTagPage()) {
			var preHandle = localeURLPart + '/collections/';
			var collectionHandleIndex = elements.indexOf("collections") + 1
			if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
			return '/collections/all/products/' + handle;
		} else {
			// Google cache URL
			// An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
			if (params.indexOf('cache:') > -1) {
				var collectionHandle = 'all';
				var temp = params.split('&')[0].split('?')[0].split('collections/');
				if (temp.length > 1) {
					if (temp[1].indexOf('/') > -1) {
						collectionHandle = temp[1].split('/')[0];
					}
					else {
						collectionHandle = temp[1];
					}
				}
				collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
                return '/collections/' + collectionHandle + '/products/' + handle;
			}
          	var collectionHandleIndex = elements.indexOf("collections") + 1;
			var preHandle = localeURLPart + '/collections/';
			if (collectionHandleIndex > 0 && typeof elements[2] !== 'undefined') {
				return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
			}
            if (collectionHandleIndex == 0 && elements.indexOf("products") !== -1) {
              var preHandle = localeURLPart + '/products/';
              return preHandle + handle;
            }
			return window.location.pathname + '/products/' + handle;
		}
	}
	return localeURLPart + '/products/' + handle;
};